var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxsWrench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.512 6.11198L17.622 10.001L14.087 6.46498L17.976 2.57598C16.7894 2.08816 15.485 1.96235 14.227 2.21439C12.9691 2.46643 11.8138 3.08505 10.9067 3.99235C9.99962 4.89965 9.38127 6.05506 9.12953 7.31308C8.87779 8.5711 9.0039 9.87549 9.492 11.062L3.216 17.337C3.12305 17.4298 3.04932 17.54 2.99901 17.6613C2.94869 17.7826 2.9228 17.9126 2.9228 18.044C2.9228 18.1753 2.94869 18.3054 2.99901 18.4267C3.04932 18.548 3.12305 18.6582 3.216 18.751L5.338 20.873C5.43079 20.9659 5.54099 21.0397 5.66231 21.09C5.78362 21.1403 5.91367 21.1662 6.045 21.1662C6.17633 21.1662 6.30638 21.1403 6.42769 21.09C6.54901 21.0397 6.65921 20.9659 6.752 20.873L13.027 14.597C14.2136 15.0855 15.5182 15.2118 16.7765 14.9602C18.0348 14.7086 19.1905 14.0902 20.098 13.183C21.0049 12.2753 21.623 11.1196 21.8747 9.86138C22.1263 8.60317 22.0001 7.29864 21.512 6.11198Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxsWrench);
export default __webpack_public_path__ + "static/media/bxBxsWrench.ea9d8ddf8e20ef0a1ac87936afcf0250.svg";
export { ForwardRef as ReactComponent };